import React from 'react';
import { forOwn as _forOwn } from 'lodash-es';

/**
 * Arbitrary additional information that is returned from the Compatio API
 *
 * @param extraData
 * @returns {Array}
 * @constructor
 */
function ProductExtraData({ extraData }) {
  const displayDataOutput = [];
  _forOwn(extraData, (extraDataLine, key) => {
    displayDataOutput.push(
      <span
        className={'xrs-product__display-data xrs-product__display-data-' + key}
        key={key}
      >
        {extraDataLine}
      </span>
    );
  });

  return displayDataOutput;
}

export default ProductExtraData;
